var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"transparent","elevation":"0","width":"auto"}},[_c('v-row',{staticClass:"pt-5"},[_c('v-col',{attrs:{"cols":_vm.isMobile ? 12 : 12}},[_c('CardInformacoesCliente',{attrs:{"dados":_vm.dados}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }